/// <reference types="@angular/localize" />

import { bootstrapApplication } from "@angular/platform-browser";
import { ServerSidePublicConfigDataResponse } from "backend/model/serverSidePublicConfigDataResponse";
import { AppComponent } from "src/standard/pages/app.component";
import { appConfig } from "src/standard/pages/app.config";

import "@total-typescript/ts-reset";

declare global {
  // eslint-disable-next-line no-var
  var __settings: ServerSidePublicConfigDataResponse | undefined;

  // eslint-disable-next-line no-var
  var __locale: string;
  // eslint-disable-next-line no-var
  var __dateLocale: string | undefined;
  // eslint-disable-next-line no-var
  var __numberLocale: string | undefined;
  // eslint-disable-next-line no-var
  var __rtl: boolean;

  // Maps a specific event name to an event type
  interface GlobalEventHandlersEventMap {
    "keydown.enter": KeyboardEvent;
    "keydown.space": KeyboardEvent;
  }
}

void bootstrapApplication(AppComponent, appConfig);
